import React from 'react';
import { mockData } from '../data/mock';

const About = () => {
  return (
    <section id="about" style={styles.section}>
      <div className="container">
        <div style={styles.content}>
          <h2 className="heading-1" style={styles.title}>{mockData.about.title}</h2>
          
          {/* Nicolas - Main Profile */}
          <div style={styles.profileSection}>
            <div style={styles.imageContainer}>
              <img 
                src="https://customer-assets.emergentagent.com/job_redcross-funding/artifacts/w8e5ueog_db9d945d-a639-4576-968f-808868ba1cdc.jpeg"
                alt="Nicolas Alexander Wahr"
                style={styles.profileImage}
              />
              <div style={styles.profileInfo}>
                <h3 style={styles.profileName}>Nicolas Alexander Wahr</h3>
                <p style={styles.profileTitle}>Geschäftsführer</p>
              </div>
            </div>
            
            <div style={styles.textContent}>
              <p className="body-large" style={styles.description}>
                {mockData.about.description}
              </p>
            </div>
          </div>
          
          {/* Sebastian Bunn - Headcoach */}
          <div style={styles.headcoachSection}>
            <div className="wahr-card" style={styles.headcoachCard}>
              <img 
                src="https://customer-assets-gfyr7b9c.emergentagent.net/job_19d7b65f-d233-45c5-81b8-fa003e7407c3/artifacts/nto0p0qo_Sebastian%20Bunn.jpg"
                alt="Sebastian Bunn"
                style={styles.headcoachImage}
              />
              <div style={styles.headcoachInfo}>
                <h3 style={styles.headcoachName}>Sebastian Bunn</h3>
                <p style={styles.headcoachTitle}>Headcoach</p>
                <p style={styles.headcoachQuote} className="body-medium">
                  "Als Headcoach bringe ich jahrelange Praxiserfahrung mit und trainiere Sie in allen Facetten des erfolgreichen Door-to-Door Fundraisings – von der ersten Ansprache bis zum erfolgreichen Abschluss."
                </p>
              </div>
            </div>
          </div>
          
          <div style={styles.statsGrid}>
            {mockData.about.stats.map((stat, index) => (
              <div key={index} className="wahr-card" style={styles.statCard}>
                <div style={styles.statValue} className="display-medium">{stat.value}</div>
                <div style={styles.statLabel} className="body-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    background: 'var(--bg-page)',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  title: {
    textAlign: 'center',
    marginBottom: '48px',
  },
  profileSection: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '48px',
    marginBottom: '48px',
    alignItems: 'center',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
  },
  profileImage: {
    width: '100%',
    maxWidth: '350px',
    height: 'auto',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(28, 46, 82, 0.15)',
    objectFit: 'cover',
  },
  profileInfo: {
    textAlign: 'center',
  },
  profileName: {
    fontSize: 'clamp(1.5rem, 3vw, 1.75rem)',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '8px',
  },
  profileTitle: {
    fontSize: 'clamp(1rem, 2vw, 1.125rem)',
    color: 'var(--brand-primary)',
    fontWeight: '500',
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  description: {
    lineHeight: '1.8',
  },
  headcoachSection: {
    marginBottom: '48px',
  },
  headcoachCard: {
    display: 'flex',
    gap: '32px',
    alignItems: 'center',
    padding: '32px',
    flexWrap: 'wrap',
  },
  headcoachImage: {
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    objectFit: 'cover',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    flexShrink: 0,
  },
  headcoachInfo: {
    flex: 1,
    minWidth: '250px',
  },
  headcoachName: {
    fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '4px',
  },
  headcoachTitle: {
    fontSize: '1.125rem',
    color: 'var(--brand-primary)',
    fontWeight: '500',
    marginBottom: '12px',
  },
  headcoachQuote: {
    fontStyle: 'italic',
    color: 'var(--text-secondary)',
    lineHeight: '1.6',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '32px',
    marginTop: '48px',
  },
  statCard: {
    padding: '32px',
    textAlign: 'center',
  },
  statValue: {
    color: 'var(--brand-primary)',
    marginBottom: '8px',
  },
  statLabel: {
    color: 'var(--text-secondary)',
  },
};

export default About;
